const SLABreachedTicketIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#FFDCDA" />
      <path
        d="M21.8333 7.66675V10.1667C21.8333 13.3884 19.2216 16.0001 16 16.0001M16 16.0001C12.7783 16.0001 10.1666 13.3884 10.1666 10.1667V7.66675M16 16.0001C19.2216 16.0001 21.8333 18.6117 21.8333 21.8334V24.3334M16 16.0001C12.7783 16.0001 10.1666 18.6117 10.1666 21.8334V24.3334"
        stroke="#FF3838"
        stroke-width="1.25"
      />
      <path
        d="M9.33337 7.66675H22.6667M22.6667 24.3334H9.33337"
        stroke="#FF3838"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default SLABreachedTicketIcon;
